import { useState } from 'react';

export const useKeyRefresher = () => {
  const [key, setKey] = useState(true);
  const refresh = () => setKey((key) => !key);

  return [key, refresh];
};
